import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

export function CustomTabPanel(props) {
  const { children, value, index, sx, stacked = false, ...other } = props;
  const isActive = value === index;
  const visible = stacked || isActive;

  return (
    <Box
      role="tabpanel"
      hidden={!visible}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{
        pt: 1,
        ...sx,
        // Active-state behavior is enforced AFTER caller sx — a caller's
        // `display: "flex"` must never override tab visibility (that made
        // every panel render at once, each squeezed to a fraction of the
        // height). In `stacked` mode (mobile), all panels render with their
        // natural height instead of flex-splitting the container.
        display: visible ? "flex" : "none",
        flexDirection: "column",
        flex: visible && !stacked ? 1 : 0,
        minHeight: 0,
        height: stacked ? "auto" : "100%",
      }}
      {...other}
    >
      {visible && children}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
